import { render, staticRenderFns } from "./SimpleConfirmDialog.vue?vue&type=template&id=2660e705&scoped=true&"
import script from "./SimpleConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleConfirmDialog.vue?vue&type=style&index=0&id=2660e705&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660e705",
  null
  
)

export default component.exports